const mutations = {
    setMasterEmailGroups(state, payload) {
      state.masterEmailgroup = payload;
    },
    setGroupsBased(state, payload) {
      state.groupsBased = payload;
    },
    setManualJournaltype(state, payload) {
      state.journalType = payload;
    },
    setManualJournalHeaderList(state, payload) {
      state.journalHeaderList = payload;
    },
    setManualJournalLine(state, payload) {
      state.journalLineList = payload;
    },
    setJournalPlanSchemeLine(state, payload) {
      state.journalPlanSchemeList = payload;
    },
    setHierarchyMasterHeaderItem(state, payload) {
      state.hierarchyMasterHeaderList = payload;
    },
    setHierarchyMasterLineItem(state, payload) {
      state.hierarchyMasterLineItemList = payload;
    },
    setHierarchyHeaderItem(state, payload) {
      state.hierarchyHeaderItem = payload;
    },
    setTargetPlanningHeaderList(state, payload) {
      state.targetPlanningHeaderList = payload;
    },
    setTargetPlanningLine(state, payload) {
      state.targetPlanningLineList = payload;
    },
    setMasterEmailDropDown(state, payload) {
      state.masterEmailGropDropDown = payload;
    },
    setTargetDeploymentMaster(state, payload) {
      state.masterTargetDeploymentDropDown = payload;
    },
    setTargetDeploymentHeaderList(state, payload) {
      state.targetDeploymentHeaderList = payload;
    },
    setTargetDeploymentLineDynamicHeader(state, payload) {
      state.targetDeploymentLineDynamicHeaderList = payload;
    },
    setTargetDeploymentLineDynamicList(state, payload) {
      state.targetDeploymentLineDynamicList = payload;
    },
  };
  
  export default mutations;
  